module.exports = __webpack_public_path__ + "person.d79ac08d7192724130b2.png";


//////////////////
// WEBPACK FOOTER
// /home/rubylover/Work/new_vin_photo/site/web/src/assets/img/person.png
// module id = ../../../../../src/assets/img/person.png
// module chunks = main